export enum AgeGroup {
  NO_PREFERENCE = 0,
  UP_TO_35 = 1,
  BETWEEN_36_AND_55 = 2,
  MORE_OR_EQUAL_56 = 3,
}

export enum PartOfDay {
  NO_PREFERENCE = 0,
  MORNING = 1,
  AFTERNOON = 2,
  EVENING = 3,
}

export enum Gender {
  MAN = 0,
  WOMAN = 1,
  NO_PREFERENCE = 2,
}

export enum DiagnosisSessionType {
  ONLINE = 0,
  OFFLINE = 1,
  HYBRID = 2,
}

export enum DiagnosisContentTopic {
  THERAPY_IMPACT = 'therapyImpact',
  THERAPY_SESSION = 'therapySession',
  PROFESSIONALS = 'professionals',
  FOUND_A_THERAPIST = 'foundATherapist',
  FOUND_A_THERAPIST_NO_REFUND = 'foundATherapistNoRefund',
  PSYCHIATRY = 'psychiatry',
}
